import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * This interceptor is responsible for handling of the machine_id or user on all PWA apps if for some
 * reason the machine_id does not exist in the cookie.
 *
 * Actually, the machine_id is being stored in the cookie from tap or middleware service where the user taps a tag or
 * scans a QR/SQR. But for some reason, there are cases that this cookie does not exist and the PWA apps are unable to determine
 * who is this user and we are unable to track what is happening or why the data is loss. One example for this scenario is that when
 * the user copy-paste the PWA url to another device/browser or even on incognito mode (This means that when that cookie does not exist).
 *
 * So now, we are not sure if there is really an error on our side or the user did something from their side like the details above.
 * In order to get more details, instead of relying in the cookie, we're gonna include the machine_id from the URL which comes from the tap
 * url (which will always be there).
 *
 * This interceptor will get this machine_id from the query parameter of the PWA url and attach it to the header of all requests that the
 * app will make, especially the PWA backend. And from there, the PWA backend will do the logic of checking if these values exist or matched,
 * and log more user information.
 */
@Injectable()
export class MachineIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    try {
      // Get the current URL
      const currentUrl = window.location.href;

      // Create a URL object from the current URL
      const url = new URL(currentUrl);
      const machineIdQuery = url.searchParams.get('machineId');

      if (!machineIdQuery) {
        return next.handle(req);
      }

      // Clone the request to add the new header.
      const clonedRequest = req.clone({
        setHeaders: {
          'Machine-Id-Query': machineIdQuery,
        },
      });

      // Pass the cloned request instead of the original request to the next handle
      return next.handle(clonedRequest);
    } catch (error) {
      // If there is an error then just proceed to the next handle
      console.error('Something went wrong in handling machine_id', error);
      return next.handle(req);
    }
  }
}
